import { AppServices, Misc } from '@singularsystems/neo-core';
import { IAppService } from '@singularsystems/neo-core/dist/AppServices';

const AppService : IAppService = new AppServices.AppService();

Misc.Globals.appService = AppService;

export { AppService };